import { Body } from 'components/Text/Body';
import { H2 } from 'components/Text/H2';
import { AmpVideoPlayer } from 'components/VideoPlayer';
import { CmsApiVideoBlockData } from 'modules/cms/api/types/blocks/CmsApiVideoBlock';

type Props = {
  data: CmsApiVideoBlockData;
};

export function CmsAmpVideoBlock({
  data: { headline, subtitle, videoUrl },
}: Props) {
  return (
    <>
      {headline && <H2>{headline}</H2>}

      {subtitle && (
        <Body
          dangerouslySetInnerHTML={{
            __html: subtitle,
          }}
        />
      )}

      <AmpVideoPlayer url={videoUrl} />
    </>
  );
}
